import fetch from '../utils/fetch';

// Networks isn't required and if left out we get everything. NO idea why they have this
// forced in. I am leaving it commented just to see if we run into errors that lead us to
// putting it back.
// DEFAULT_NETWORKS = 'twitter,facebook,instagram,youtube,zipwhip,twilio,reddit,tiktok,heymarket';
const STORY_BASE = process.env.STORY_API;

export default {
  getFeaturedPosts(tagboardId) {
    return fetch(`${STORY_BASE}/posts/${tagboardId}`);
  },
};
